import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Tenant } from 'src/models';

@Injectable({
  providedIn: 'root',
})
export class SharedTenantService {
  private selectedTenantSubject = new BehaviorSubject<Partial<Tenant> | null>(null);
  public selectedTenant$ = this.selectedTenantSubject.asObservable();

  setSelectedTenant(tenant: Partial<Tenant> | null) {
    this.selectedTenantSubject.next(tenant);
  }

  getSelectedTenant(): Partial<Tenant> | null {
    return this.selectedTenantSubject.value;
  }
}
